export default function StoreConfig() {
  return (
    <>
      <p>This Page should house all Store Configuration information: </p>
      <p> POS IP Scheme</p>
      <p>This tab describes IP mapping for all devices in a store. This page can be edited only if the correct role is assigned</p>
      <p> MENU ITEM</p>
      <p>This tab shows menu items available connectivity per store. This page can be edited only if the correct role is assigned</p>
      <p>STS CONNECTIVITY</p>
      <p>This tab shows the connectivity status of the Store to STS. This page is for monitoring purposes and cannot be edited</p>
    </>
  );
}
